import { render } from "./read.vue?vue&type=template&id=7cbd46c5&scoped=true"
import script from "./read.vue?vue&type=script&lang=js"
export * from "./read.vue?vue&type=script&lang=js"

import "./read.vue?vue&type=style&index=0&id=7cbd46c5&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cbd46c5"]])

export default __exports__